// import React from "react";
// import { Card, Typography, Box } from "@mui/material";
// import "./ReceiverMessage.css";
// import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// const ReceiverMessage = ({ message, handleDownload, formatMessageTime }) => {
//   // Use the formatMessageTime prop if provided, otherwise format locally
//   const formattedTime = formatMessageTime 
//     ? formatMessageTime(message.createdAt)
//     : new Date(message.createdAt).toLocaleTimeString('en-US', { 
//         hour: '2-digit', 
//         minute: '2-digit',
//         hour12: true 
//       });

//   // Common card styles for all message types
//   const cardStyles = {
//     bgcolor: '#F2F1EB',
//     p: 1.5,
//     borderRadius: '4px 18px 18px 18px',
//     minWidth: '60px',
//     maxWidth: '300px',
//     width: 'fit-content'
//   };

//   const renderMessageContent = () => {
//     if (message.contentType === "file") {
//       return (
//         <Card sx={cardStyles}>
//           <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems="center" mb={0.5}>
//             <Typography variant="body2" sx={{ 
//               fontWeight: 500,
//               wordBreak: 'break-word',
//               minWidth: '120px'
//             }}>
//               {message.fileName}
//             </Typography>
//             {
//               message?.download ?
//                 <CheckCircleIcon sx={{ fontSize: '18px', color: 'green', flexShrink: 0 }} />
//                 :
//                 <DownloadForOfflineIcon
//                   sx={{ fontSize: '18px', cursor: 'pointer', color: '#666', flexShrink: 0 }}
//                   onClick={handleDownload}
//                 />
//             }
//           </Box>
//           <Box display='flex' justifyContent='flex-end' mt={0.5}>
//             <Typography variant="caption" sx={{ 
//               color: '#666', 
//               fontSize: '11px',
//               fontWeight: 500
//             }}>
//               {formattedTime}
//             </Typography>
//           </Box>
//         </Card>
//       );
//     } else if (message.contentType === "audio") {
//       return (
//         <Card sx={{
//           ...cardStyles,
//           minWidth: '200px', // Audio needs more minimum width
//           maxWidth: '250px'  // Audio player max width
//         }}>
//           <Box mb={0.5} sx={{ width: '100%' }}>
//             <audio 
//               controls 
//               style={{ 
//                 width: '100%', 
//                 height: '36px',
//                 minWidth: '180px' // Ensure audio player has enough width
//               }}
//             >
//               <source src={message.content} type="audio/mpeg" />
//               Your browser does not support the audio element.
//             </audio>
//           </Box>
//           <Box display='flex' justifyContent='flex-end' mt={0.5}>
//             <Typography variant="caption" sx={{ 
//               color: '#666', 
//               fontSize: '11px',
//               fontWeight: 500
//             }}>
//               {formattedTime}
//             </Typography>
//           </Box>
//         </Card>
//       );
//     } else {
//       // Text message - Make width consistent with file messages
//       return (
//         <Card sx={{
//           ...cardStyles,
//           minWidth: '80px' // Text messages slightly wider minimum
//         }}>
//           <Typography variant="body1" sx={{ 
//             wordBreak: 'break-word',
//             display: 'inline-block',
//             minWidth: '40px',
//             paddingRight: '20px'
//           }}>
//             {message.content}
//           </Typography>
//           <Box display='flex' justifyContent='flex-end' mt={0.5}>
//             <Typography variant="caption" sx={{ 
//               color: '#666', 
//               fontSize: '11px',
//               fontWeight: 500
//             }}>
//               {formattedTime}
//             </Typography>
//           </Box>
//         </Card>
//       );
//     }
//   };

//   return renderMessageContent();
// };

// export default ReceiverMessage;


import React, { useState } from "react";
import { Card, Typography, Box } from "@mui/material";
import "./ReceiverMessage.css";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from "react-toastify";

const ReceiverMessage = ({ message, handleDownload, formatMessageTime }) => {
  // Use the formatMessageTime prop if provided, otherwise format locally
  const formattedTime = formatMessageTime 
    ? formatMessageTime(message.createdAt)
    : new Date(message.createdAt).toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      });

  // Common card styles for all message types
  const cardStyles = {
    bgcolor: '#F2F1EB',
    p: 1.5,
    borderRadius: '4px 18px 18px 18px',
    minWidth: '60px',
    maxWidth: '300px',
    width: 'fit-content'
  };

  // Function to view file content - handles both base64 and downloaded files
  const viewFileContent = () => {
    // Check if file content exists in the message
    if (message.fileContent) {
      // File content is available in base64 format
      const fileExtension = message.fileName?.split('.').pop()?.toLowerCase() || '';
      const mimeTypes = {
        'pdf': 'application/pdf',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'txt': 'text/plain',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'ppt': 'application/vnd.ms-powerpoint',
        'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      };

      const mimeType = mimeTypes[fileExtension] || 'application/octet-stream';
      
      try {
        // Convert base64 to blob
        const byteCharacters = atob(message.fileContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        const fileURL = URL.createObjectURL(blob);
        
        // Open in new tab
        window.open(fileURL, '_blank');
        
        // Clean up URL object after some time
        setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
      } catch (error) {
        console.error("Error processing file content:", error);
        toast.error("Error opening file");
      }
    } else if (message.downloadedFilePath) {
      // If file has been downloaded and we have a path
      // Open the downloaded file (this would typically be handled by backend)
      window.open(message.downloadedFilePath, '_blank');
    } else if (message.download) {
      // File has been downloaded but we don't have the path
      // You might want to fetch the file from local storage or server
      toast.info("File has been downloaded. Check your downloads folder.");
    } else {
      // No file content available
      toast.warning("File content is not available for viewing. Please download it first.");
    }
  };

  // Function to handle download
  const handleFileDownload = () => {
    if (message.fileContent) {
      // Call parent's handleDownload function
      handleDownload(message.fileContent, message.fileName, message.messageId);
    } else {
      toast.warning("File content is not available for download");
    }
  };

  const renderMessageContent = () => {
    if (message.contentType === "file") {
      // Check if file has been downloaded
      const isDownloaded = message.download || false;
      const hasContent = !!message.fileContent;
      
      return (
        <Card sx={cardStyles}>
          <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems="center" mb={0.5}>
            <Typography variant="body2" sx={{ 
              fontWeight: 500,
              wordBreak: 'break-word',
              minWidth: '120px',
              color: isDownloaded ? 'green' : 'inherit'
            }}>
              {message.fileName || 'Unnamed file'}
              {isDownloaded && ' ✓'}
            </Typography>
            <Box display="flex" gap={1}>
              {/* View button - show if file has content or is downloaded */}
              {(hasContent || isDownloaded) && (
                <VisibilityIcon
                  sx={{ 
                    fontSize: '18px', 
                    cursor: 'pointer', 
                    color: '#666',
                    '&:hover': { color: '#1976d2' }
                  }}
                  onClick={viewFileContent}
                  title={isDownloaded ? "View downloaded file" : "View file"}
                />
              )}
              
              {/* Download/Downloaded indicator */}
              {
                isDownloaded ? (
                  <CheckCircleIcon 
                    sx={{ 
                      fontSize: '18px', 
                      color: 'green', 
                      flexShrink: 0,
                      cursor: 'pointer'
                    }}
                    title="Already downloaded - click to view"
                    onClick={viewFileContent}
                  />
                ) : (
                  <DownloadForOfflineIcon
                    sx={{ 
                      fontSize: '18px', 
                      cursor: 'pointer', 
                      color: '#666',
                      '&:hover': { color: '#1976d2' }
                    }}
                    onClick={handleFileDownload}
                    title="Download file"
                  />
                )
              }
            </Box>
          </Box>
          <Box display='flex' justifyContent='flex-end' mt={0.5}>
            <Typography variant="caption" sx={{ 
              color: '#666', 
              fontSize: '11px',
              fontWeight: 500
            }}>
              {formattedTime}
            </Typography>
          </Box>
        </Card>
      );
    } else if (message.contentType === "audio") {
      return (
        <Card sx={{
          ...cardStyles,
          minWidth: '200px', // Audio needs more minimum width
          maxWidth: '250px'  // Audio player max width
        }}>
          <Box mb={0.5} sx={{ width: '100%' }}>
            <audio 
              controls 
              style={{ 
                width: '100%', 
                height: '36px',
                minWidth: '180px' // Ensure audio player has enough width
              }}
            >
              <source src={message.content} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </Box>
          <Box display='flex' justifyContent='flex-end' mt={0.5}>
            <Typography variant="caption" sx={{ 
              color: '#666', 
              fontSize: '11px',
              fontWeight: 500
            }}>
              {formattedTime}
            </Typography>
          </Box>
        </Card>
      );
    } else {
      // Text message - Make width consistent with file messages
      return (
        <Card sx={{
          ...cardStyles,
          minWidth: '80px' // Text messages slightly wider minimum
        }}>
          <Typography variant="body1" sx={{ 
            wordBreak: 'break-word',
            display: 'inline-block',
            minWidth: '40px',
            paddingRight: '20px'
          }}>
            {message.content}
          </Typography>
          <Box display='flex' justifyContent='flex-end' mt={0.5}>
            <Typography variant="caption" sx={{ 
              color: '#666', 
              fontSize: '11px',
              fontWeight: 500
            }}>
              {formattedTime}
            </Typography>
          </Box>
        </Card>
      );
    }
  };

  return renderMessageContent();
};

export default ReceiverMessage;